import {createContext} from 'react';

import {AnswerService} from './services/answerService';
import {InboxService} from './services/InboxService';
import {TagService} from './services/tagService';

/*
 * Types.
 */

export interface RuleEditorServiceContext {
  inboxService: InboxService;
  tagService: TagService;
  answerService: AnswerService;
}

/*
 * Context.
 */

export const RuleEditorServiceContext = createContext<RuleEditorServiceContext>(null!);

export const createRuleEditorServiceContext = (): RuleEditorServiceContext => ({
  tagService: new TagService(),
  inboxService: new InboxService(),
  answerService: new AnswerService(),
});
